//////////////////////////////////////////////////////////////////////
// This editor is specific for the model: Answer
//////////////////////////////////////////////////////////////////////
import React, { Component } from 'react'
import styled from 'styled-components'
import { graphql, compose } from 'react-apollo'
import WithLoan from '../../shared/WithLoan'
import { UpdateData, PayrollInfoQuery } from '../queries/index'
import {
  StaticContainer,
  EditorContainer,
  ToggleBtn,
  EditContainerHeader,
  Form,
  Input,
  Textarea,
  Checkbox,
  CheckboxContainer,
  Submit
} from '../common/stylesheets/index'
import UpdateDataUtil from '../common/utils/UpdateDataUtil'
import Formats from '../../shared/utils/Formats'

const Label = styled.p`
  margin: 0;
`
//////////////////////////////////////////////////////////////////////
// The attributes that need to be displayed for this model:
// - value
//////////////////////////////////////////////////////////////////////

class AnswerEditor extends Component {
  constructor(props) {
    super(props)
    const { object: { value } } = props
    this.state = {
      editModeOn: false,
      value,
      isDisabled: true
    }
  }
  get question() {
    const { helpers: { questions }, object: { questionNumber } } = this.props

    return questions.find(({ number }) => number === questionNumber)
  }
  get originalValue() {
    const { props: { object: { value } } } = this

    return value
  }
  get objectValue() {
    const { props: { object: { type } } } = this
    const { numberToCurrency } = Formats

    let objectValue
    switch (type) {
      // add more cases here for different types inthe future
      case 'Answer::Enumerate':
        objectValue = this.getOptionsLabels().map((label, i) => <Label key={`label-${i}`}>{label};</Label>)
        break
      case 'Answer::Decimal':
        objectValue = numberToCurrency(this.originalValue, false, '$')
        break
      default:
        objectValue = this.originalValue
        break
    }

    return objectValue
  }
  getSlitOptions = value => (
    value?.split(',') || []
  )
  getOptionsLabels = () => {
    const { selectOptions } = this.question
    const options = this.getSlitOptions(this.originalValue)

    let labels = []
    selectOptions.map(option => {
      const [label, value] = option
      if (options.includes(value)) {
        labels = labels.concat(label)
      }
    })

    return labels
  }
  toggleEdition = () => {
    const { editModeOn } = this.state

    this.setState({ editModeOn: !editModeOn })
  }
  toggleEditionCancel = () => {
    this.setState({ value: this.originalValue, isDisabled: true })
    this.toggleEdition()
  }
  onChange = e => {
    const { target: { value } } = e

    this.setState({ value, isDisabled: value === this.originalValue })
  }
  onChangeCheckbox = e => {
    const { value } = this.state
    const { checked, value: valueChecked } = e.target
    let options = this.getSlitOptions(value)

    if (checked && !options.includes(valueChecked)) {
      options = options.concat([valueChecked])
    } else if (!checked) {
      options = options.filter(item => item !== valueChecked)
    }
    const joinValue = options.join(',')

    this.setState({ value: joinValue, isDisabled: joinValue === this.originalValue })
  }
  onSubmit = async e => {
    e.preventDefault()
    e.stopPropagation()

    await this._updateData()
    this.toggleEdition()
  }
  _updateData = async () => {
    const { updateData, loan: { rid: loanId }, object: { rid: objectId } } = this.props
    const { value } = this.state
    const input = {
      model: 'answer',
      id: objectId,
      attribute: 'value',
      value,
      loanId: String(loanId)
    }
    UpdateDataUtil({ updateData, input, query: PayrollInfoQuery, loanId })
  }
  renderForm = () => {
    const { props: { object: { type } }, state: { value, isDisabled } } = this

    let element
    switch (type) {
      case 'Answer::Enumerate':
        const { selectOptions } = this.question
        const options = this.getSlitOptions(value)

        element = (
          selectOptions.map(([label, numberValue], i) => (
            <CheckboxContainer key={`label-${i}`}>
              <Checkbox
                type="checkbox"
                value={numberValue}
                onChange={this.onChangeCheckbox}
                defaultChecked={options.includes(numberValue)}
              />
              <label>{label}</label>
            </CheckboxContainer>
          ))
        )
        break
      case 'Answer::Text':
        element = (
          <Textarea
            value={value}
            onChange={this.onChange}
          />
        )
        break
      default:
        element = (
          <Input
            value={value}
            onChange={this.onChange}
          />
        )
        break
    }

    return (
      <Form onSubmit={this.onSubmit}>
        {element}
        <Submit type="submit" disabled={isDisabled}>
          Save
        </Submit>
      </Form>
    )
  }
  renderStatic = () => {
    const { objectValue, props: { canEditRow } } = this

    return (
      <StaticContainer>
        <span>
          {objectValue}
        </span>
        {canEditRow && (
          <ToggleBtn onClick={this.toggleEdition}>
            Edit
          </ToggleBtn>
        )}
      </StaticContainer>
    )
  }
  renderEdit = () => (
    <EditorContainer>
      <EditContainerHeader>
        {this.renderForm()}
        <ToggleBtn onClick={this.toggleEditionCancel}>
          Cancel
        </ToggleBtn>
      </EditContainerHeader>
    </EditorContainer>
  )
  render() {
    const { state: { editModeOn }, renderStatic, renderEdit } = this

    return (
      editModeOn ? renderEdit() : renderStatic()
    )
  }
}

export { AnswerEditor }

export default compose(
  graphql(UpdateData, {
    name: 'updateData'
  }),
  WithLoan
)(AnswerEditor)
